export enum MediaPushStatusValues {
    Pending = 'PENDING',
    Completed = 'COMPLETED',
    Failed = 'FAILED',
}

export enum MediaApprovalStatusValues {
    Pending = 'PENDING',
    Approved = 'APPROVED',
    Rejected = 'REJECTED',
}

export enum MediaTestingStatusValues {
    Pending = 'PENDING',
    Approved = 'APPROVED',
    Rejected = 'REJECTED',
}

export interface MediaPushStatus {
    media_id: number
    status: MediaPushStatusValues
    checked_by?: string
    date_start?: number
    created_at: number
    updated_at: number
}

export default interface Media {
    approval_description: string
    approval_request_at?: number
    chain_id: number
    chain: number
    created_at: number
    date_end?: number
    date_start?: number
    date_upload_ended?: number
    date_upload_started?: number
    file_size: number
    hdr: boolean
    height: number
    id: number
    is_approved: MediaApprovalStatusValues
    is_tested: MediaTestingStatusValues
    length: number
    md5: string
    media_push_status: MediaPushStatus[]
    name: string
    path: string
    playlists: []
    render_tool_id?: number
    tags: {}
    temp_path?: string
    testing_description: string
    type?: string
    updated_at: number
    uploaded_by?: string
    width: number
}
